export const initialErrors = {
  title: String() || null,
  color: String() || null,
};
export type initialErrorsType = typeof initialErrors;

export const initialOrderStateGroup = {
  _id: '',
  title: '',
  titleEn: '' as string | null,
  titleKu: '' as string | null,
  color: '',
};
export type initialOrderStateGroupType = typeof initialOrderStateGroup;

// Picker swatches for the create/edit dialog.
export const groupColorPalette = [
  '#F59E0B',
  '#F97316',
  '#EF4444',
  '#EC4899',
  '#8B5CF6',
  '#6366F1',
  '#3B82F6',
  '#06B6D4',
  '#10B981',
  '#22C55E',
  '#84CC16',
  '#64748B',
];

// Reserved droppable id for the unmapped row at the top of the board.
export const UNMAPPED_DROPPABLE_ID = 'unmapped';
